import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { ToastrService } from 'ngx-toastr';
import { ParamPhoneMaskHn } from 'src/app/@core/constants';
import { CatalogsResponse } from 'src/app/models/catalogs';
import { CatalogsService } from 'src/app/services/catalogs.service';
import { ExceptionSolutionService } from 'src/app/services/exception-solution.service';
import { ParamsService } from 'src/app/services/params.service';

@Component({
  selector: 'app-pos-reason-select-modal',
  templateUrl: './pos-reason-select-modal.component.html',
  styleUrls: ['./pos-reason-select-modal.component.sass'],
})
export class PosReasonSelectModalComponent implements OnInit {
  @Input() catalogCode: string = '';
  @Input() title = "";
  @Output() selectedReasonChange: EventEmitter<CatalogsResponse> =
    new EventEmitter();

  reasons: CatalogsResponse[] = [];
  selectedReason: CatalogsResponse | undefined;


  public reasonForm = this.formBuilder.group({
    reasonCode: this.formBuilder.control(null, Validators.required),
    reasonDescription: this.formBuilder.control(null, Validators.required),
    manualReasonDescription: this.formBuilder.control(null),
    knowsOwnerPhone: this.formBuilder.control(true),
    ownerPhone: this.formBuilder.control(null)
  });

  phoneMask: string = "";
  constructor(
    private catalogsService: CatalogsService,
    public bsModalRef: BsModalRef,
    private formBuilder: FormBuilder,
    private toastr: ToastrService,
    private readonly exceptionSolutionService: ExceptionSolutionService,
    private readonly paramService: ParamsService
  ) { }

  async ngOnInit(): Promise<void> {
    this.phoneMask = (await this.paramService.readParam(ParamPhoneMaskHn).toPromise()).response.value ?? "";

    this.reasonForm.get("knowsOwnerPhone")?.valueChanges.subscribe((o) => {
      if (o == 'false') {
        this.reasonForm.get("ownerPhone")?.disable();
      }
      else {
        this.reasonForm.get("ownerPhone")?.enable();
      }
    })
  }

  cancel() {
    if (this.selectedReason != undefined) {
      if (this.selectedReason.isTextFreeDescription) {
        if (this.reasonForm.get('manualReasonDescription')?.value == null) {
          this.exceptionSolutionService.showAlertWithSolution(`Motivo de no actualización`, `Debe de ingresar un motivo`);
          return;
        }
      }
      this.bsModalRef.hide();
      this.selectedReasonChange.emit(this.selectedReason);
      this.selectedReasonChange.complete();
    } else {
      this.exceptionSolutionService.showAlertWithSolution(`Motivo de no actualización`, `Debe de seleccionar un motivo`);
    }
  }

  async confirm(): Promise<void> {
    if (this.selectedReason != undefined) {
      if (this.selectedReason.isTextFreeDescription) {
        if (this.reasonForm.get('manualReasonDescription')?.value == null) {
          this.exceptionSolutionService.showAlertWithSolution(`Motivo de no actualización`, `Debe de ingresar un motivo`);
          return;
        }
        this.selectedReason.description =
          `${this.selectedReason.description}-${this.reasonForm.get('manualReasonDescription')?.value}`;
      }
      this.selectedReason.ownerPhone = this.reasonForm.value.ownerPhone;
      this.selectedReasonChange.emit(this.selectedReason);
      this.selectedReasonChange.complete();
      this.bsModalRef.hide();
    } else {
      this.exceptionSolutionService.showAlertWithSolution(`Motivo de no actualización`, `Debe de seleccionar un motivo`);
    }
  }

  changeType() {
    this.selectedReason = this.reasons.find(
      (reason) => reason.code === this.reasonForm.get('reasonCode')?.value
    );
    this.reasonForm.patchValue({
      reasonDescription: this.selectedReason?.description,
    });
  }

  async loadReasons(): Promise<void> {
    this.reasons = (
      await this.catalogsService
        .getCatalogByCatalogCode(this.catalogCode)
        .toPromise()
    ).response.content;
  }

  get knowsOwnerPhone() {
    return this.reasonForm.get('knowsOwnerPhone')?.value != 'false';
  }
}
